var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgMobileMenuClose = function SvgMobileMenuClose(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.414L17.657 19.071C17.8456 19.2532 18.0982 19.354 18.3604 19.3517C18.6226 19.3494 18.8734 19.2442 19.0588 19.0588C19.2442 18.8734 19.3494 18.6226 19.3517 18.3604C19.354 18.0982 19.2532 17.8456 19.071 17.657L13.414 12L19.071 6.343C19.2532 6.1544 19.354 5.9018 19.3517 5.6396C19.3494 5.3774 19.2442 5.12659 19.0588 4.94118C18.8734 4.75577 18.6226 4.6506 18.3604 4.64833C18.0982 4.64605 17.8456 4.74684 17.657 4.929L12 10.586L6.343 4.929C6.15355 4.75134 5.90241 4.65437 5.64273 4.65858C5.38305 4.6628 5.13519 4.76788 4.95161 4.95159C4.76803 5.13531 4.66312 5.38324 4.65909 5.64292C4.65505 5.90261 4.75221 6.15368 4.93 6.343L10.586 12L4.929 17.657C4.83349 17.7492 4.75731 17.8596 4.7049 17.9816C4.65249 18.1036 4.6249 18.2348 4.62375 18.3676C4.6226 18.5004 4.6479 18.6321 4.69818 18.755C4.74846 18.8779 4.82271 18.9895 4.9166 19.0834C5.0105 19.1773 5.12215 19.2515 5.24505 19.3018C5.36794 19.3521 5.49962 19.3774 5.6324 19.3763C5.76518 19.3751 5.8964 19.3475 6.0184 19.2951C6.14041 19.2427 6.25075 19.1665 6.343 19.071L12 13.414Z",
    fill: "#010101"
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgMobileMenuClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mobile-menu-close.b66893982c2d1b452bde5b004b4625e2.svg";